<div class="address-summary">
  <!-- Invoice Address -->
  <div class="clearfix">
    <a
      class="float-right btn-tool"
      [routerLink]="addressLink()"
      title="{{ 'checkout.address.update.label' | translate }}"
      aria-label="Edit invoice address"
    >
      <fa-icon [icon]="['fas', 'pencil-alt']" />
    </a>
    <h5 class="float-left">{{ 'checkout.address.billing.label' | translate }}</h5>
  </div>
  <div data-testing-id="address-summary-invoice-to-address">
    <ish-address [address]="basket().invoiceToAddress" [displayEmail]="true" />
  </div>

  <!-- Shipping Address -->
  <div class="clearfix">
    <a
      class="float-right btn-tool"
      [routerLink]="addressLink()"
      title="{{ 'checkout.address.update.label' | translate }}"
      aria-label="Edit shipping address"
    >
      <fa-icon [icon]="['fas', 'pencil-alt']" />
    </a>
    <h5>{{ 'checkout.address.shipping.label' | translate }}</h5>
  </div>
  <div data-testing-id="address-summary-ship-to-address">
    @if (basket().invoiceToAddress.id === basket().commonShipToAddress?.id) {
    <address>
      {{ 'checkout.same_as_billing_address.text' | translate }}
    </address>
    } @else { @if (basket().buckets.length > 1) {
    <div>
      {{ 'dias.multiple.shpping.checkout.multiple.address.text' | translate }}
    </div>
    } @else {
    <ish-address [address]="basket().commonShipToAddress" />
    } }
  </div>
</div>
